import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import NbsTransactionApiUrls from 'src/apiUrls/NbsTransactionApiUrls'
import React from 'react'
import NbsTransactionKeys from 'src/constants/locale/key/NbsTransaction'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    DateRangeFilter: CngDateRangeFilter,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.NBS_TRANSACTION
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let nbsTransaction = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: nbsTransaction
      }
    )
    let idType = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.ID_TYPE
    )
    let userId = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.USER_ID
    )
    let chargeCode = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.CHARGE_CODE
    )
    let appId = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.APP_ID
    )
    let transactionDate = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.TRANSACTION_DATE
    )
    let transactionId = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.TRANSACTION_ID
    )
    let transType = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.TRANS_TYPE
    )
    let paymentStatus = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.PAYMENT_STATUS
    )
    let remarks1 = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.REMARKS1
    )
    let remarks2 = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.REMARKS2
    )
    let remarks3 = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.REMARKS3
    )
    let remarks4 = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.REMARKS4
    )
    let remarks5 = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.REMARKS5
    )
    let remarks6 = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.REMARKS6
    )
    let module = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.MODULE
    )
    let msgFunction = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.MSG_FUNCTION
    )
    let billInd = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.BILL_IND
    )
    let quantity = translate(
      Namespace.NBS_TRANSACTION,
      NbsTransactionKeys.QUANTITY
    )

    return {
      nbsTransaction,
      tableTitle,
      idType,
      userId,
      chargeCode,
      appId,
      transactionDate,
      transactionId,
      transType,
      paymentStatus,
      remarks1,
      remarks2,
      remarks3,
      remarks4,
      remarks5,
      remarks6,
      module,
      msgFunction,
      billInd,
      quantity
    }
  }

  const columns = [
    {
      field: "idType",
      title: translatedTextsObject.idType,
    },
    {
      field: "userId",
      title: translatedTextsObject.userId,
    },
    {
      field: "chargeCode",
      title: translatedTextsObject.chargeCode,
    },
    {
      field: "appId",
      title: translatedTextsObject.appId,
    },
    {
      field: "transactioDate",
      title: translatedTextsObject.transactionDate,
      type: "date",
      filterComponent: CngDateRangeFilter,
      defaultSort: 'desc',
      render: (rowData) => {
        return moment(rowData.createdDate).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    {
      field: "transactionId",
      title: translatedTextsObject.transactionId,
    },
    {
      field: "transType",
      title: translatedTextsObject.transType,
    },
    {
      field: "paymentStatus",
      title: translatedTextsObject.paymentStatus,
    },
    {
      field: "remarks1",
      title: translatedTextsObject.remarks1,
    },
    {
      field: "remarks2",
      title: translatedTextsObject.remarks2,
    },
    {
      field: "remarks3",
      title: translatedTextsObject.remarks3,
    },
    {
      field: "remarks4",
      title: translatedTextsObject.remarks4,
    },
    {
      field: "remarks5",
      title: translatedTextsObject.remarks5,
    },
    {
      field: "remarks6",
      title: translatedTextsObject.remarks6,
      render: (rowData) => {
        return moment(rowData.createdDate).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    {
      field: "module",
      title: translatedTextsObject.module,
    },
    {
      field: "msgFunction",
      title: translatedTextsObject.msgFunction,
    },
    {
      field: "billInd",
      title: translatedTextsObject.billInd,
    },
    {
      field: "quantity",
      title: translatedTextsObject.quantity,
      type: "numeric",
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              // addRoute={`${pathname}/add`}
              columns={columns}
              // del={{ url: NbsTransactionApiUrls.DELETE }}
              // editRoute={`${pathname}/edit`}
              exportData={{ url: NbsTransactionApiUrls.EXPORT }}
              fetch={{ url: NbsTransactionApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              options={{
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100, 500, 1000],
                toolbar: true
              }}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              // viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
